import { css, keyframes } from '@emotion/css';
import { theme } from '@repo-sapiens/theme';
import React from 'react';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

type GoogleButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  text: string;
  width?: string;
  animate?: boolean;
  animationDelay?: number;
  type?: 'button' | 'submit' | 'reset';
};

export const LightButton: React.FC<GoogleButtonProps> = ({
  onClick,
  text,
  width = '100%',
  animate = false,
  animationDelay = 0,
  type = 'button',
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={css`
        border-radius: 76px;
        background: transparent;
        max-width: 540px;
        width: ${width};
        height: 48px;
        cursor: pointer;
        color: ${theme.colors.text.primary};

        font-family: ${theme.font.button.fontFamily};
        font-size: ${theme.font.button.fontSize};
        font-style: normal;
        font-weight: 900;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 18px;
        border: 2px solid #2e2d33;

        opacity: ${animate ? 0 : 1};

        animation: ${animate
          ? `${fadeIn} 1s ease-in-out ${animationDelay}s forwards;`
          : 'none'};
      `}
    >
      {text}
    </button>
  );
};
